import Aspect169Icon from 'assets/svgr-icons/Aspect_Ratio_16_9_Dropdown.svg'
import Aspect916Icon from 'assets/svgr-icons/Aspect_Ratio_9_16_Dropdown.svg'
import { ASPECT_RATIO_PER_TYPE } from 'containers/SubSidebar/AiImageContent/consts'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

export const getAspectRatioOptions = () => [
  {
    key: 'landscape' as const,
    label: translate(T.WIDESCREEN_LABEL),
    ratio: ASPECT_RATIO_PER_TYPE.landscape,
    icon: Aspect169Icon
  },
  {
    key: 'portrait' as const,
    label: translate(T.PORTRAIT_LABEL),
    ratio: ASPECT_RATIO_PER_TYPE.portrait,
    icon: Aspect916Icon
  }
]
